import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

/* Cinematic black sweep on route change (skips initial load — splash owns it) */
const PageTransition = () => {
  const location = useLocation();
  const first = useRef(true);
  const [sweepKey, setSweepKey] = useState(null);

  useEffect(() => {
    if (first.current) {
      first.current = false;
      return;
    }
    setSweepKey(location.pathname + Date.now());
  }, [location.pathname]);

  return (
    <AnimatePresence>
      {sweepKey && (
        <motion.div
          key={sweepKey}
          initial={{ scaleY: 1 }}
          animate={{ scaleY: 0 }}
          transition={{ duration: 0.45, ease: [0.76, 0, 0.24, 1] }}
          onAnimationComplete={() => setSweepKey(null)}
          className="fixed inset-0 z-[95] pointer-events-none bg-[#02050c]"
          style={{ transformOrigin: "top" }}
          data-testid="page-transition"
        >
          <div className="absolute bottom-0 inset-x-0 h-px" style={{ background: "linear-gradient(90deg, transparent, #E5C56F 40%, #A855F7 60%, transparent)", boxShadow: "0 0 24px rgba(229,197,111,0.5)" }} />
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default PageTransition;
